import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface EaDataTableColumn {
  label: string;
  key: string;
  num?: boolean;
  bold?: boolean;
  muted?: boolean;
  soft?: boolean;
  badge?: boolean;
}

@Component({
  selector: 'ea-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss'],
  standalone: false,
})
export class EaDataTableComponent {
  @Input() title?: string;
  @Input() hint?: string;
  @Input() columns: EaDataTableColumn[] = [];
  @Input() rows: any[] = [];
  @Input() emptyText = 'Aucune donnée';
  @Input() loading = false;
  @Input() footerRow?: any;

  @Input() showPager = false;
  @Input() page = 1;
  @Input() totalPages = 1;

  @Output() prev = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
}
